import { FC } from "react";
import { HiveMarkCellContainer } from "features/hives/ui/hivesTable/styles.ts";
import { MarkColorsType } from "./types";

export type HiveMarkProps = {
    number: number | null;
    color: string | number | null;
};
// eslint-disable-next-line
export const markColors: MarkColorsType[] = [
    {
        id: 0,
        borderColor: "--border-soft",
        mainColor: "--static-white",
    },
    {
        id: 1,
        mainColor: "--warning-default",
    },
    {
        id: 2,
        mainColor: "--error-default",
    },
    {
        id: 3,
        mainColor: "--status-02-default",
    },
    {
        id: 4,
        mainColor: "--success-default",
    },
];

export const HiveMarkCell: FC<HiveMarkProps> = ({ number = 0, color }) => {
    const colorId = Number(color);
    const currentMark = markColors.find((el) => el.id === colorId) || markColors[0];

    const bgColor = currentMark.mainColor;
    const borderColor = currentMark.borderColor;

    return (
        <HiveMarkCellContainer
            style={{
                background: `var(${bgColor})`,
                border: borderColor ? `1px solid var(${borderColor})` : "none",
                color:
                    color == 0
                        ? "var(--warning-on-warning, rgba(51, 33, 3, 1))"
                        : "",
            }}
        >
            {number}
        </HiveMarkCellContainer>
    );
};
